export const SET_HISTORY = 'router/SET_HISTORY';
export const BOOTSTRAP_ROUTER = 'router/HANDLE_FIRST_ROUTER_URL';
export const REQUEST_CHANGE_ROUTER = 'router/REQUEST_CHANGE_ROUTER';
export const LEAVING_ROUTER = 'router/LEAVING';
export const CHANGE_ROUTER = 'router/CHANGE';
export const REPLACE_ROUTER = 'router/REPLACE';
export const UPDATE_URL = 'router/UPDATE_URL';
export const CONFIRM_REROUTING = 'router/CONFIRM_REROUTING';
export const BLOCK_ROUTER = 'router/BLOCK_ROUTER';
export const UNBLOCK_ROUTER = 'router/UNBLOCK_ROUTER';
